<template>
  <div class="checkup-recommendations">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`) },
        { title: this.$t('menu.checkup_plus/recommendations'), disabled: true }
    ]">

      <!--<div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :active-filters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>-->

    </Breadcrumbs>
    <fade-transition
      :duration="400"
      mode="out-in">
      <div class="btn btn__floating"
           v-if="showSave">
        <va-popover
          :message="$t('users.save')"
          placement="left"
        >
          <va-button
            :disabled="isLoading"
            @click.prevent="handleSaveChanges">
            <span class="is-bold" style="font-size: 17px">{{$t('users.save')}}</span>
          </va-button>

        </va-popover>
      </div>
    </fade-transition>

    <div>
      <div class="table-container">
        <div class="text-center loading-overlay" v-if="isLoading">
          <LoadingAnimation/>
        </div>

        <div>
          <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
            <div class="row">
              <div class="col-12 col-md-4">
                <label class="form-label">
                  {{ $t('dashboard_new_evollu.titles.facility') }}
                </label>
                <multiselect
                  id="entities-filter"
                  v-model="filters.facility"
                  :options="readableFacilities"
                  track-by="id"
                  :customLabel="formatedEntityLabel"
                  :placeholder="$t('dashboard_new_evollu.titles.facility')"
                  :allow-empty="true"
                  :multiple="false"
                  :internal-search="true"
                  :disabled="!readableFacilities.length || readableFacilities.length === 1"
                >

                  <template slot="clear">
                    <!--<span class="multiselect__clear" v-if="filters.entities.length"
                          @mousedown.prevent.stop="filters.entities = []"></span>-->
                    <span class="multiselect__clear" v-if="filters.facility !== null"
                          @mousedown.prevent.stop="filters.facility = null"></span>
                  </template>
                </multiselect>
              </div>

              <div class="col-12 col-md-4">
                <label class="form-label">
                  {{ $t('dashboard_new_evollu.titles.parameter') }}
                </label>
                <multiselect
                  id="measurement-charts-filter"
                  v-model="filters.chart"
                  :options="allowedMeasurementCharts"
                  track-by="id"
                  :customLabel="elem => $t(`checkup_plus.charts.byId.${elem.id}`)"
                  :placeholder="$t('dashboard_new_evollu.titles.parameter')"
                  :allow-empty="true"
                  :multiple="false"
                  :internal-search="true"
                  :disabled="allowedMeasurementCharts === null || !filters.facility || isLoading"
                >

                  <template slot="clear">
                    <!--<span class="multiselect__clear" v-if="filters.entities.length"
                          @mousedown.prevent.stop="filters.entities = []"></span>-->
                    <span class="multiselect__clear" v-if="filters.chart !== null"
                          @mousedown.prevent.stop="filters.chart = null"></span>
                  </template>
                </multiselect>
              </div>

              <div class="col-12 col-md-4">
                <label class="form-label">
                  {{ $t('iframe.table_headings.lang') }}
                </label>
                <multiselect
                  id="lang"
                  v-model="filters.lang"
                  :options="langOptions"
                  track-by="lang"
                  :custom-label="(opt) => opt.language_key ? `${opt.emoji} ${$t(`language.${opt.language_key}`)}` : 'N/A'"
                  :placeholder="$t('iframe.table_headings.lang')"
                  :allow-empty="false"
                  :multiple="false"
                  :internal-search="true"
                  :disabled="allowedMeasurementCharts === null || !filters.facility || isLoading"
                >
                </multiselect>
              </div>
            </div>

          </div>
        </div>


        <div v-if="recommendationsData">
          <h5 class="ml-3 mt-2">{{$t('menu.checkup_plus/recommendations') + ' - ' + $t(`checkup_plus.charts.byId.${filters.chart.id}`)}}</h5>

          <!--<v-client-table
            id="checkupRecommendationsTable"
            ref="checkupRecommendationsTable"
            name="checkupRecommendationsTable"
            :data="recommendationsData"
            :columns="columns"
            :options="tableOptions">

            <span slot="criteria" slot-scope="props">
              {{$t(`dashboard_new_evollu.parameters.graphs.legends.${props.row.chartResult.code.toLowerCase()}`)}}
            </span>

          </v-client-table>-->


          <div class="ml-3 mr-3 mt-3 recommendations-card-container">
            <div class="row col-12 recommendations-card-header">
              <div class="row col-md-4 mt-2 justify--center">
                <label class="header-lbl">{{$t('checkup_plus.alerts.table.criteria')}}</label>
              </div>
              <div class="row col-md-6 mt-2 justify--center">
                <label class="header-lbl">{{$t('checkup_plus.reports.patient_overall_summary.recommendation')}}</label>
              </div>
              <div class="row col-md-2 w-100 d-flex justify-content-center mt-2 justify--center">
                <label class="header-lbl">{{$t('iframe.pages_configurator.headings.actions')}}</label>
              </div>
            </div>
            <div v-for="data in recommendationsData">
              <div class="row col-12 recommendations-card-row ml-2">
                <div class="row col-md-4 mt-2">
                  <span>{{$t(`dashboard_new_evollu.parameters.graphs.legends.${data.chartResult.code.toLowerCase()}`)}}</span>
                </div>
                <div class="row col-md-6 mt-2 align-items-center">
                  <span v-if="data.isBeingEdited === false">{{data.recommendationEdited}}
                    <va-popover
                      v-if="data.isBeingEdited === false"
                      class="ml-2"
                      placement="top"
                      :message="$t('leads-web.leads.edit')">
                      <i class="fa fa-pencil clickable color-evollu-green" @click="data.isBeingEdited = true"></i>
                    </va-popover>
                  </span>
                  <input
                    v-else
                    @input="error = null"
                    @focusout="handleEditingRecommendation(data)"
                    v-model="data.recommendationEdited"
                    type="text"
                    class="rounded-input"
                    maxLength="254"
                  >
                  <va-popover
                    v-if="data.recommendationEdited !== null && data.recommendation.trim() !== data.recommendationEdited.trim()"
                    class="ml-2"
                    placement="top"
                    :message="$t('checkup_plus.recommendations.titles.not_sync')">
                    <i class="fa-solid fa-cloud-arrow-up" style="color: #d3ae25"></i>
                  </va-popover>
                </div>
                <div class="row col-md-2 w-100 d-flex justify-content-center mt-2">
                  <va-popover
                    v-if="data.recommendation !== data.recommendationDefault"
                    class="ml-2"
                    placement="top"
                    :message="$t('checkup_plus.recommendations.titles.revert_to_default')">
                    <i class="fa-solid fa-rotate-left clickable" @click="handleRevertToDefault(data)"></i>
                  </va-popover>
                  <span v-else> --- </span>
                </div>
              </div>
              <hr class="separator"/>
            </div>

          </div>
        </div>
        <div v-else>
          <div class="no-data-disclaimer">
            <h5> {{$t('please_select_filter_to_show_data')}} </h5>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import Searchable from '@/components/common/Searchable.vue';
import Filters from '@/components/common/Filters.vue';
import { OneCareService } from '@/api/OneCareService';
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation.vue';
import Multiselect from 'vue-multiselect';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
import { mapState } from 'vuex';
import Vue from 'vue';
import { ClientTable } from 'vue-tables-2';
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin.vue';
import FadeTransition from '@/components/common/transitions/FadeTransition.vue';
import { EntityService } from '@/api/AuthService';

const CHECKUP_RECOMMENDATIONS_INFO_TYPE = 130

Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  props: {
    component: {
      type: Object,
      required: true,
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin,
    IsFromEvolluMixin
  ],
  components: { FadeTransition, Multiselect, LoadingAnimation, Filters, Searchable, Breadcrumbs },
  data: function () {
    return {
      isLoading: false,
      showFilters: true,
      activeFilters: 0,
      querySearch: '',
      langOptions: this.$store.state.languages,
      filters: {
        facility: null,
        chart: null,
        lang: null,
      },
      allowedMeasurementCharts: [],
      recommendationsData: null
    }
  },
  async created() {

  },
  methods: {
    handleRevertToDefault: function(rec) {
      rec.recommendationEdited = rec.recommendationDefault
    },
    handleSaveChanges: async function(val) {
      this.isLoading = true;
      const editedRecommendations = this.recommendationsData.filter(rec => rec.recommendation.trim() !== rec.recommendationEdited.trim() && rec.recommendationEdited.trim() !== rec.recommendationDefault.trim())

      try {
        const data = []
        for (const elem of editedRecommendations) {
          let bodyData = {}
          const lang = this.filters.lang ? this.filters.lang.lang : 'pt'
          bodyData.locale = lang
          bodyData.chartResult = {id: elem.chartResult.id}
          bodyData.entityId = this.filters.facility.entity_id
          bodyData.facilityId = this.filters.facility.id
          bodyData.recommendation = elem.recommendationEdited
          if(elem.isDefault !== true) {
            bodyData.id = elem.id
          }
          data.push(bodyData)
        }
        if(data.length > 0) {
          await OneCareService.patchRecommendation(lang, this.filters.facility.id, this.filters.chart.id, data)
        }


        const revertedRecommendations = this.recommendationsData.filter(rec => rec.recommendationEdited.trim() === rec.recommendationDefault.trim() && rec.isDefault === false)
        for (const rec of revertedRecommendations) {
          await OneCareService.revertDeleteRecommendation(rec.id);
          await new Promise(resolve => setTimeout(resolve, 300));
        }


        await this.gatherRecommendations()
      } catch (e) {
        console.log(e.message)
        this.showToast(this.$t('auth.tfa.errors.generic'), this.$store.state.errorToastOptions)
      } finally {
        this.isLoading = false
      }
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    gatherRecommendations: async function () {
      this.isLoading = true
      const facilityId = this.filters.facility ? this.filters.facility.id : null
      const entityId = this.filters.facility ? this.filters.facility.entity_id : null
      const lang = this.filters.lang ? this.filters.lang.lang : 'pt'
      try {
        const resp = await OneCareService.getRecommendations(lang, facilityId, this.filters.chart.id)
        resp.forEach(elem => {
          elem.recommendationEdited = elem.recommendation
          elem.isBeingEdited = false
        })
        this.recommendationsData = resp
      } catch (e) {
        this.showToast(this.$t('dashboard_new_evollu.errors.ghathering_recommendations'), this.$store.state.errorToastOptions)
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    handleEditingRecommendation: function (data) {
      data.isBeingEdited = false
    },
    getAllowedMeasurementsGroupData: async function(facility) {
      this.isLoading = true
      const res = await EntityService.getCheckupEntityMeasurementGroups(facility.entity_id)
      this.allowedMeasurementCharts = this.measurementCharts.filter(elem => res.some(group => elem.m_group === group.checkup_measurement_group_id))
      this.isLoading = false
    }
  },
  computed: {
    ...mapState({
      measurementCharts (state, getters) {
        return getters[`checkup/measurementCharts`] || null
      },
    }),
    checkupPlusService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.onecare_server) || null
    },
    readableEntities: function () {
      if (!this.checkupPlusService) {
        return []
      }
      let permissions = this.checkupPlusService.user_permissions.filter(
        p => p.info_type === CHECKUP_RECOMMENDATIONS_INFO_TYPE && p.access_type >= this.$store.state.accessTypes.READ
      )

      if (permissions.some(p => p.entity_id === null)) {
        return [...this.checkupPlusService.entities]
      } else {
        return this.checkupPlusService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
      }
    },
    readableFacilities: function () {
      if (!this.readableEntities.length) {
        return []
      }
      const facilities = this.readableEntities.map(entity => entity.facilities).flat()
      if(facilities.length === 1) {
        this.filters.facility = facilities[0]
      }
      return facilities
    },
    showSave: function() {
      return this.recommendationsData && this.recommendationsData.length && this.recommendationsData.length > 0 && this.recommendationsData.some(rec => rec.recommendation.trim() !== rec.recommendationEdited.trim())
    },
  },
  watch: {
    'filters': {
      handler: function(newVal) {
        if(this.filters.facility && this.filters.chart) {
          this.gatherRecommendations()
        }
      },
      deep: true
    },
    'filters.facility': {
      handler: function(newVal) {
        if (newVal === null) {
          this.filters.lang = null
          this.filters.chart = null
          this.allowedMeasurementCharts = []
          this.recommendationsData = null
          --this.activeFilters
        } else {
          ++this.activeFilters
          const lang = this.langOptions.find(elem => elem.lang === this.$auth.user().entity.country.toLowerCase())
          if(lang) {
            this.filters.lang = lang
          } else {
            this.filters.lang = this.langOptions[0]
          }

          this.getAllowedMeasurementsGroupData(newVal)
        }
      },
    },
    'filters.chart': {
      handler: function(newVal) {
        if (newVal === null) {
          this.filters.facility = null
          this.recommendationsData = null
          --this.activeFilters
        } else {
          ++this.activeFilters
        }
      },
    },
    'filters.lang': {
      handler: function(newVal) {
        if (newVal === null) {
          this.filters.lang = null
          this.recommendationsData = null
          --this.activeFilters
        } else {
          ++this.activeFilters
        }
      },
    },
  }
};
</script>

<style lang="scss">

.table-container {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

.no-data-disclaimer {
  width: 100%;
  margin-top: 20px;
  border-radius: 12px;
  background-color: rgb(246, 236, 221);
  height: 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  h5 {
    color: #878787;
  }
}

.recommendations-card-row {
  margin-top: 20px !important;
  align-content: center;
  height: 40px !important;
}

.recommendations-card-container {
  border-radius: 10px;
  border: 1px solid #e3e2e2;
  margin: 0px !important;
}

.recommendations-card-header {
  align-content: center;
  border-radius: 10px;
  background-color: #eaeaea;
  margin: unset !important;
  height: 50px !important;
}

@import "~vuestic-ui/src/components/vuestic-sass/vuestic-styles";

.header-lbl{
  //padding-left: 5px;
  color: $evollu-dark;
  font-weight: bold;
  font-size: 17px;
}

.color-evollu-green {
  color: $evollu-dark;
}
.separator {
    // box-shadow: 0px 3px 8px 2px #e8e8e8;
    // margin-bottom: 3rem;
    margin-bottom: 30px;
    margin-top: -30px;
    border: none;
    height: 50px;
    box-shadow: 0 20px 20px -20px #dad8d8;
}

.rounded-input {
  border-radius: 20px; /* Adjust the border-radius to control the roundness */
  padding: 10px; /* Add padding for spacing */
  border: 1px solid #ccc; /* Add border for visual separation */
  outline: none; /* Remove default focus outline */
  width: 95%;
}

.rounded-input:focus {
  border-color: #7dca52; /* Change border color on focus */
  box-shadow: 0 0 5px #7dca52; /* Add shadow effect on focus */
}
</style>
